"use client";
import { gridColumns } from "./gridColumns";
import { callersGridColumns } from "./callersGridColumns";
import Web3 from 'web3';
import { isTelegramWebApp as detectTelegramWebApp } from './platform';


const isBrowserDefaultDark = () => window.matchMedia('(prefers-color-scheme: dark)').matches;
export const getDefaultTheme = () => {
    const localStorageTheme = localStorage.getItem('default-theme');
   // const browserDefault = isBrowserDefaultDark() ? 'dark' : 'light';
    const browserDefault = isBrowserDefaultDark() ? 'dark' : 'dark';
    return localStorageTheme || browserDefault;
};

const isNumber = (char) => {
    return /^\d$/.test(char);
}

export const guid = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
}

export const modifiedTokenHash = (str) => {
    let string = '';
    if(str) {
        const start = str.substr(0, 5);
        const end = str.substr(string.length - 4);
        string = start + '...' + end;
    }
    return string;
}

export const customSort = (valueA, valueB, nodeA, nodeB, isDescending) => {
    // First: check the values at the end of the string for char like % or k... etc. and remove it
    const lastvalueACharIsNotNumber = !isNumber(valueA[valueA.length - 1]);
    const lastvalueBCharIsNotNumber = !isNumber(valueB[valueB.length - 1]);
    
    let a = valueA;
    //console.log(valueA.charAt(valueA.length - 1))
    //console.log(isNumber(valueA[valueA.length - 1]))
    let b = valueB;
    // remove the last char if is not integer
    if(lastvalueACharIsNotNumber) {
        a = a.slice(0, -1);
    }
    if(lastvalueBCharIsNotNumber) {
        b = b.slice(0, -1);
    }
    // remove '+' at the begining
    if(a.charAt(0) === '+') {
        a = a.slice(1);
    }
    let aNum = parseFloat(a);
    if(b.charAt(0) === '+') {
        b = b.slice(1);
    }
    let bNum = parseFloat(b);
    if (aNum === bNum) return 0;
    return (aNum > bNum) ? 1 : -1;
}


export const createGridColumns = (paramsArray, isCallersPage) => {
    // paramsArray must be an array of desired columns e.g. ['TokenName', 'BuyLink'...]
    let columns = [];
    let columnArr = gridColumns;
    if(isCallersPage) {
        columnArr = callersGridColumns;
    }
    if(paramsArray && paramsArray.length > 0) {
        for(var i = 0; i < paramsArray.length; i++) {
            // eslint-disable-next-line no-loop-func
            columnArr.forEach((item) => {
                const currentItem = paramsArray[i];
                if(currentItem === item.field) {
                    columns.push(item);
                }
            })
        }
        return columns;
    }
}

// Replace your existing connectUserWallet function with this:

export const connectUserWallet = async (walletAddress) => {
    // Check if wallet already exists in localStorage
    let storageWallet = localStorage.getItem('userWallet');
    
    if (storageWallet) {
        // Wallet already exists, return it
        return JSON.parse(storageWallet);
    }

    // No wallet in storage, fetch balance from blockchain
    try {
        const balanceOfABI = [
            {
                constant: true,
                inputs: [
                    {
                        name: '_owner',
                        type: 'address',
                    },
                ],
                name: 'balanceOf',
                outputs: [
                    {
                        name: 'balance',
                        type: 'uint256',
                    },
                ],
                payable: false,
                stateMutability: 'view',
                type: 'function',
            },
        ];
        
        //const ethContrAddres = '0xD76b5c2A23ef78368d8E34288B5b65D616B746aE';
        // const tokenContract = '0xa0e7626287bd02cbe3531c65148261bf0c0ed98b'; // Shillguard Token address
        // const web3 = new Web3(new Web3.providers.HttpProvider('https://mainnet.infura.io/v3/85158e6cdcef4ac08ec2edc4ced2b81e'));
        // const contract = new web3.eth.Contract(balanceOfABI, tokenContract);
        
        // // Get balance for the connected wallet
        // let result = await contract.methods.balanceOf(walletAddress).call();
        // let amount = typeof result === 'bigint' ? result.toString() : result;
        
        // // Create wallet object
        // const wallet = {
        //     address: walletAddress,
        //     amount: amount
        // };
        
        // // Save to localStorage
        // localStorage.setItem('userWallet', JSON.stringify(wallet));
        const wallet = { };
        return wallet;
        
    } catch (error) {
        console.error('Error fetching wallet balance:', error);
        return {
            errorMsg: 'Failed to fetch wallet balance. Please try again.'
        };
    }
};
export const getWallet = () => {
    let w = {};
    let stWallet = localStorage.getItem('userWallet');
    //console.log(JSON.stringify(stWallet))
    if(stWallet) {
        // get the value and cut the last character ('n')
        let storageWallet = JSON.parse(stWallet);
        let tokenValue;
        // if(storageWallet.amount && storageWallet.amount.toString() !== '0') {
        //     tokenValue = storageWallet.amount.slice(0, -1);
        // }
        // else {
        //     tokenValue = storageWallet.amount;
        // }
        tokenValue = storageWallet.amount;
        // Get the first 18 decimals of the amount (Token Contract (WITH 18 Decimals)) 
        let amount = tokenValue;
        w = {
            address: storageWallet.address,
            //amount: amount.slice(0, -6),
            amount: amount
        }
        //console.log(wallet)
    }
    
    return w;
}

export const minPremiumAmount = () => {
    const minAmount = 49999;
    return minAmount;
}

export const checkIsPremium = (w) => {
    let isPremium = false;
    let stWallet = localStorage.getItem('userWallet');
    const wallet = w ? w : JSON.parse(stWallet);
    if(stWallet && wallet && wallet.amount && wallet.amount > minPremiumAmount()) {
        isPremium = true;
    }
    return isPremium;
}

export const addToWatchList = (data) => {
    //console.log(data)
    const watchList = localStorage.getItem('watchlist');
    let list;
    if(watchList && watchList !== "[{}]" && watchList !== "[]") {
        list = JSON.parse(watchList);
    }
    else {
        list = [];
    }
    const item = {
        id: data.ID,
        nameOfCallGroup: data.NameOfCallGroup,
        cryptoGroupImage: data.CryptoGroupImage
    }
    // 1.check if the item is added to the list
    const filtered = list.filter((listItem) => listItem.id === data.ID);
    const itemExists = filtered.length > 0;
    if(!itemExists) {
        list.push(item);
    }
    localStorage.setItem('watchlist', JSON.stringify(list));
}  

export const removeFromList = (data) => {
    const watchList = localStorage.getItem('watchlist');
    let parsed = JSON.parse(watchList);
    if(parsed && parsed.length === 1) {
        localStorage.removeItem('watchlist');
    }
    else {
        let filtered = parsed.filter((item) => item.nameOfCallGroup !== data.NameOfCallGroup);
        localStorage.setItem('watchlist', JSON.stringify(filtered)); 
    }  
}


export const maskingString = (str, start, end) => {
   if (!str || start < 0 || start >= str.length || end < 0 || end > str.length || start >= end) {
      return str;
   }
   const maskLength = end - start;
   const maskedStr = str.substring(0, start) + "*".repeat(maskLength) + str.substring(end);
   return maskedStr;
}


export const isTelegramWebApp = detectTelegramWebApp;